module.exports = "agm-map{\r\n    height: 400px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main